import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/talentos/talentos.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const TalentoViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedTalento,
    selectedTalentoLoading,
    selectedTalentoError,
  } = useSelector((state) => state.talentos);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle del talento"
      size="lg"
    >
      {selectedTalentoLoading && (
        <Loader
          center
          text="Cargando información del talento..."
          delay={150}
          type="dots"
        />
      )}

      {selectedTalentoError && (
        <p className="text-danger">{selectedTalentoError}</p>
      )}

      {!selectedTalentoLoading && selectedTalento && (
        <div className="row g-4">
          {/* Información principal */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:star-outline"
                label="Nombre"
                value={selectedTalento.nombre}
              />
              <Field
                icon="mdi:toggle-switch"
                label="Estado"
                value={selectedTalento.is_active ? "Activo" : "Inactivo"}
              />
            </div>
          </div>

          {/* Descripción */}
          <div className="col-md-6">
            <Field
              icon="mdi:text-box-outline"
              label="Descripción"
              value={selectedTalento.descripcion}
              justify
            />
          </div>

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedTalento.created_at}
              updatedAt={selectedTalento.updated_at}
              createdBy={selectedTalento.created_by}
              updatedBy={selectedTalento.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default TalentoViewModal;
